import { useEffect } from 'react';
export var SIDEBAR_DND_SCROLL_EDGE_PX = 80;
var MAX_SCROLL_STEP = 28;
export var isPointerInScrollEdge = function isPointerInScrollEdge(container, clientY) {
  var edgePx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SIDEBAR_DND_SCROLL_EDGE_PX;

  if (!container) {
    return false;
  }

  var rect = container.getBoundingClientRect();

  if (clientY < rect.top || clientY > rect.bottom) {
    return false;
  }

  return clientY - rect.top < edgePx || rect.bottom - clientY < edgePx;
};
/**
 * HTML5 DnD does not auto-scroll nested overflow containers.
 * Listen to native `dragover` (no React re-renders) and scroll when the pointer
 * is near the top/bottom edge. Live hover-reorder is paused in that zone so
 * layout shifts do not fight the scroll.
 */

export var useDragAutoScroll = function useDragAutoScroll(containerRef) {
  useEffect(function () {
    var pointer = {
      x: 0,
      y: 0,
      active: false
    };
    var frameId = 0;
    var running = false;

    var stop = function stop() {
      pointer.active = false;
      running = false;

      if (frameId) {
        window.cancelAnimationFrame(frameId);
        frameId = 0;
      }
    };

    var tick = function tick() {
      if (!pointer.active) {
        running = false;
        return;
      }

      var container = containerRef.current;

      if (container) {
        var rect = container.getBoundingClientRect();
        var distanceFromTop = pointer.y - rect.top;
        var distanceFromBottom = rect.bottom - pointer.y;
        var inHorizontalBounds = pointer.x >= rect.left - 24 && pointer.x <= rect.right + 24;
        var delta = 0;

        if (inHorizontalBounds) {
          if (distanceFromTop >= 0 && distanceFromTop < SIDEBAR_DND_SCROLL_EDGE_PX) {
            delta = -Math.ceil((SIDEBAR_DND_SCROLL_EDGE_PX - distanceFromTop) / SIDEBAR_DND_SCROLL_EDGE_PX * MAX_SCROLL_STEP);
          } else if (distanceFromBottom >= 0 && distanceFromBottom < SIDEBAR_DND_SCROLL_EDGE_PX) {
            delta = Math.ceil((SIDEBAR_DND_SCROLL_EDGE_PX - distanceFromBottom) / SIDEBAR_DND_SCROLL_EDGE_PX * MAX_SCROLL_STEP);
          }
        }

        if (delta !== 0) {
          var maxScroll = container.scrollHeight - container.clientHeight;
          var next = Math.min(Math.max(0, container.scrollTop + delta), maxScroll);

          if (next !== container.scrollTop) {
            container.scrollTop = next;
          }
        }
      }

      frameId = window.requestAnimationFrame(tick);
    };

    var onDragOver = function onDragOver(event) {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      pointer.active = true;

      if (!running) {
        running = true;
        frameId = window.requestAnimationFrame(tick);
      }
    };

    document.addEventListener('dragover', onDragOver);
    document.addEventListener('dragend', stop);
    document.addEventListener('drop', stop);
    return function () {
      stop();
      document.removeEventListener('dragover', onDragOver);
      document.removeEventListener('dragend', stop);
      document.removeEventListener('drop', stop);
    };
  }, [containerRef]);
};